




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EmailFieldValidator extends Vue {
  @Prop() readonly label!: string;
  @Prop() readonly name!: string;
  @Prop() readonly value!: string;

  public isValid (): boolean {
    const emailReg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/); // eslint-disable-line
    return this.value === undefined || this.value === null || this.value.trim() === '' || emailReg.test(this.value);
  }

  public getMessage (): string {
    const message = (this.label !== undefined && this.label !== '') ? this.label : this.name;
    return message + ' is not a valid email';
  }

  public getValidationClass (): string {
    return this.isValid() ? 'field-validation-valid' : 'field-validation-error';
  }
}
